<template>
  <div class="project-entry breakdown-popup">
    <div class="background-click-detector" @click="closePopup()"></div>
    <div class="project-entry-wrapper">
      <div class="popup-exit" @click="closePopup">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:avocode="https://avocode.com/"
          id="SVGDoc"
          width="22"
          height="27"
          version="1.1"
          viewBox="0 0 22 27"
        >
          <defs />
          <desc>Generated with Avocode.</desc>
          <g>
            <g>
              <title>close</title>
              <path
                d="M9.15986,25.54362c0,0.80252 -0.62895,1.45636 -1.40274,1.45636h-6.35636c-0.77379,0 -1.40274,-0.65384 -1.40274,-1.45636v-23.31371c0,-0.80309 0.62895,-1.45683 1.40274,-1.45683h6.35636c0.77379,0 1.40274,0.65374 1.40274,1.45683c0,0.80328 -0.62895,1.45693 -1.40274,1.45693h-4.95481v20.39928h4.95481c0.77379,0 1.40274,0.65374 1.40274,1.4575zM21.87376,13.93016c0.02015,0.35725 -0.12231,0.74883 -0.39876,1.03903l-4.80282,4.15678c-0.22542,0.23775 -0.58031,0.39129 -0.9588,0.39129c-0.37885,0 -0.73373,-0.15354 -0.99945,-0.43163c-0.54467,-0.56829 -0.54467,-1.49174 0.00119,-2.05879l1.94395,-1.68324h-9.6947c-0.77379,0 -1.40393,-0.65355 -1.40393,-1.45731c0,-0.80252 0.63014,-1.45636 1.40393,-1.45636h9.66263l-1.87135,-1.61791c-0.5852,-0.60673 -0.58639,-1.53074 -0.04172,-2.09885c0.26572,-0.27752 0.6206,-0.43068 0.99945,-0.43068c0.37849,0 0.73338,0.15249 0.99909,0.43068l4.71973,4.07524c0.31924,0.33197 0.4617,0.72327 0.44155,1.14174z"
                fill="#7b7b8a"
                fill-opacity="1"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="project-content-wrapper">
        <div class="form-input-wrapper">
          <label class="form-label">
            <span>{{ $t('crm.edit_dialog.select_status') }}</span>
          </label>
          <CustomDropdown
                :id="'drop_single_type'"
                v-model="selected_status"
                :init_text="$t('crm.edit_dialog.select_status')"
                style="font-size: 0.8vw;"
                :drop_items="sales_status_list"
              />
        </div>
        <div class="project-dropdowns clanovi-tima-wrapper">
          <form-autocomplete-single
            :label="$t('crm.edit_dialog.assigned_person')"
            type="clanovi_tima"
            id="clanovi-tima-eventi"
            ref="clan"
            :placeholder="$t('crm.edit_dialog.select_person')"
            :items="clanovi"
          ></form-autocomplete-single>
        </div>

        <div class="button-create-wrapper">
          <div @click="saveData" class="button-default button-create">
            <span>{{ $t("repetitive.save") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import formAutocomplete from "@/components/formElements/formAutocompleteSingle.vue";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import FormAutocompleteSingle from "../formElements/formAutocompleteSingle.vue";
import $ from "jquery";
export default {
  components: { formAutocomplete, CustomDropdown, FormAutocompleteSingle },
  name: "CrmEditInfo",
  props: [
    "is_edit",
    "old_data",
    "clanovi",
    "drop_items",
    "service_types",
    "sales_status_list",
  ],

  methods: {
    closePopup() {
      this.$emit("closeMe");
    },

    saveData() {
      this.old_data.lead_handler =
        this.selected_person.results_final.uid != ""
          ? this.selected_person.results_final.uid
          : null;

      if (this.is_edit) {
        delete this.old_data["odvjetnik"];
      }


      const response_data = {
        lead_handler : this.selected_person.results_final.uid != ""
          ? this.selected_person.results_final.uid
          : null,
          status : this.selected_status
      }

      this.$emit("edit", response_data);
    },

    getDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },
  },
  data() {
    return {
      selected_person: null,
      selected_status : null
    };
  },

  mounted() {
    this.selected_person = this.$refs.clan.$data;
    if (this.old_data.odvjetnik) {
      let tmp_odvj = this.old_data.odvjetnik;

      this.selected_person.results_final = {
        name: tmp_odvj.ime + " " + tmp_odvj.prezime,
        uid: tmp_odvj.uid,
      };
    }
    this.selected_status = this.old_data.crm_client_status.id
  },
};
</script>
